import * as React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'

const checkedIcon = require('src/assets/wizard/checkmark_white.png')

interface Props {
  checked: boolean
  answerKey: string
  onClick: () => void
  children?: any
}

export const Answer = (props: Props) => {
  const handleClick = (e) => {
    const { onClick } = props
    e.preventDefault()
    onClick()
  }

  const { checked, children, answerKey } = props
  return (
    <Container>
      <AnswerButton
        id={answerKey}
        onClick={(e) => handleClick(e)}
        color={checked ? 'white' : '#4a4a4a'}
        highlightColor={checked ? '#a7c9cd' : 'white'}>
        {children}
      </AnswerButton>
      {checked ? <img alt='checked' src={checkedIcon} /> : null}
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  width: 100%;
  margin: 5px;

  & > img {
    position: absolute;
    top: 50%;
    right: 0;
    width: 30px;
    transform: translate(-50%, -50%);
    ${media.tablet` width: 25px; `}
    ${media.phone` display: none; `}
  }
`

const AnswerButton = styled.button`
  width: 100%;
  padding: 3%;
  background: ${(props) => props.highlightColor};
  font-size: 17px;
  outline: none;
  border: 2px solid #a7c9cd;
  border-radius: 0;
  color: ${(props) => props.color};
  will-change: background;
  transition: background 0.2s ease;
`

export default Answer



// WEBPACK FOOTER //
// ./src/components/atoms/wizard/Answer.tsx